import { createService } from '@betty/toolkit/api';
import { FavoriteSchema, UnfavoriteSchema } from './FavoritesService.schemas';
import { Game } from '../../state/shared/games.types';

export default createService(
  {
    favorite: {
      method: 'POST',
      url: ({ gameId }: { gameId: Game['id'] }) => `/favorites/${gameId}`,
      responseSchema: FavoriteSchema,
    },
    unfavorite: {
      method: 'DELETE',
      url: ({ gameId }: { gameId: Game['id'] }) => `/favorites/${gameId}`,
      responseSchema: UnfavoriteSchema,
    },
  },
  ({ userId }) => `/Players/${userId}`,
);
